const awesomeIcons = [
  { icon: "chess-board", title: "Boards", categ: "Board" },
  { icon: "book", title: "Books", categ: "Book" },
  { icon: "chess", title: "Pieces", categ: "Pieces" },
];

const productCategories = ["Board", "Book", "Pieces"];

export { awesomeIcons, productCategories };
